export default __webpack_public_path__ + "images/industry.png?0a761a779c70f503d1eda5866dc70dfc";